/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum DocumentType {
  BillOfLading = "bill_of_lading",
  CarrierScannedBillOfLading = "carrier_scanned_bill_of_lading",
  ProofOfDelivery = "proof_of_delivery",
  CarrierWeightReport = "carrier_weight_report",
  CommercialInvoice = "commercial_invoice",
  PackingList = "packing_list",
  CargoClaimsForm = "cargo_claims_form",
  CertificateOfOrigin = "certificate_of_origin",
  DangerousGoodsForm = "dangerous_goods_form",
  PurchaseOrder = "purchase_order",
  InsuranceCertificate = "insurance_certificate",
  ExportLicense = "export_license",
  ShipperPhoto = "shipper_photo",
  ClaimsOtherDocument = "claims_other_document",
  ClaimsPhoto = "claims_photo",
  ClaimsOriginalInvoice = "claims_original_invoice",
  Image = "image",
  PickupPackage = "pickup_package",
  Unknown = "unknown",
  CustomerEmailAttachment = "customer_email_attachment",
  CarrierEmailAttachment = "carrier_email_attachment",
  SentEmailAttachment = "sent_email_attachment",
  EmailAttachment = "email_attachment",
  InterlineBillOfLading = "interline_bill_of_lading",
  CustomsDocument = "customs_document",
  GoogleMapsScreenshot = "google_maps_screenshot",
  LoadingDiagram = "loading_diagram",
  InvoiceAuditReport = "invoice_audit_report",
  CarrierFreightInvoice = "carrier_freight_invoice",
  CustomerScannedBillOfLading = "customer_scanned_bill_of_lading",
  CustomerScannedPod = "customer_scanned_pod",
  CustomerPhotoFreightAtPickup = "customer_photo_freight_at_pickup",
  CustomerPhotoFreightAtDelivery = "customer_photo_freight_at_delivery",
  CustomerPhotoLoadOnTruck = "customer_photo_load_on_truck",
  InterlineLabel = "interline_label",
}

export function instanceOfDocumentType(value: any): boolean {
  for (const key in DocumentType) {
    if (Object.prototype.hasOwnProperty.call(DocumentType, key)) {
      if (DocumentType[key as keyof typeof DocumentType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DocumentTypeFromJSON(json: any): DocumentType {
  return DocumentTypeFromJSONTyped(json, false);
}

export function DocumentTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentType {
  return json as DocumentType;
}

export function DocumentTypeToJSON(value?: DocumentType | null): any {
  return value as any;
}

export function DocumentTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): DocumentType {
  return value as DocumentType;
}
